export const SET_SUSPENDED_STATUS = '[SUSPEND] SET STATUS STATUS'
export const CLEAR_SUSPENDED = '[SUSPEND] CLEAR STATUS'

export const setSuspendedStatus = (payload) => ({
  type: SET_SUSPENDED_STATUS,
  payload,
})
export const clearSuspended = () => ({ type: CLEAR_SUSPENDED })
